import { KnowledgeBaseConsultActionSettings } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/KnowledgeBaseConsultActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionController';
import 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/components/actions/Actions.scss';
import './KnowledgeBaseConsultActionView.scss';
export class KnowledgeBaseConsultActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$translate', '$rootScope', 'UndoRedoService', 'state', '$timeout', '$scope', 'onOpenSchemaEditor', 'onOpenCatalogSelector', 'onCloseCatalogSelector', 'BuilderAiAgentService', 'BlipToastService'];
    constructor(close, action, $onStateChanged, $translate, $rootScope, UndoRedoService, state, $timeout, $scope, onOpenSchemaEditor, onOpenCatalogSelector, onCloseCatalogSelector, BuilderAiAgentService, BlipToastService) {
        super(close, action, $onStateChanged, UndoRedoService, state, {
            $rootScope,
            $scope,
            onOpenSchemaEditor,
        });
        this.BlipToastService = BlipToastService;
        this.showDescriptionError = false;
        this.selectedCatalogsCount = 0;
        this.chunkSize = 3;
        this.savedCatalogSetup = null;
        this.catalogsWithDocuments = [];
        this.onCatalogSelectionChange = async (selectionData) => {
            try {
                const activeCatalogs = selectionData.catalogs
                    .filter((catalog) => catalog.hasSelectedDocuments)
                    .map((catalog) => ({
                    id: catalog.id,
                    status: 'active',
                }));
                const inactiveDocuments = [];
                selectionData.catalogs.forEach((catalog) => {
                    if (catalog.hasSelectedDocuments) {
                        catalog.documents?.forEach((doc) => {
                            if (!doc.selected) {
                                inactiveDocuments.push({
                                    id: doc.id,
                                    catalog_id: catalog.id,
                                    status: 'inactive',
                                });
                            }
                        });
                    }
                });
                const payload = {
                    top_k: this.chunkSize,
                    catalogs: activeCatalogs,
                    documents: inactiveDocuments,
                };
                await this.BuilderAiAgentService.setAgentGroundingToolSetup(this.state.id, this.action.$id, this.chunkSize, activeCatalogs, inactiveDocuments);
                this.savedCatalogSetup = payload;
                this.selectedCatalogsCount = selectionData.selectedCatalogsCount;
                this.$timeout(() => {
                    this.$rootScope.$applyAsync();
                });
                this.BlipToastService.show('success', {
                    title: this.$translate.instant('knowledgeBaseConsult.toasts.documentSelectionSuccess.title'),
                    msg: this.$translate.instant('knowledgeBaseConsult.toasts.documentSelectionSuccess.message'),
                });
            }
            catch (error) {
                console.error('Error saving catalog selection:', error);
                this.BlipToastService.show('danger', {
                    title: this.$translate.instant('knowledgeBaseConsult.toasts.documentSelectionError.title'),
                    msg: this.$translate.instant('knowledgeBaseConsult.toasts.documentSelectionError.message'),
                });
            }
        };
        this.onChunkSizeBlur = async () => {
            if (this.chunkSize < 3 || isNaN(this.chunkSize)) {
                this.chunkSize = 3;
            }
            if (this.chunkSize > 50) {
                this.chunkSize = 50;
            }
            try {
                const catalogs = this.savedCatalogSetup?.catalogs || [];
                const documents = (this.savedCatalogSetup?.documents || []).map((doc) => ({
                    id: doc.id,
                    catalog_id: doc.catalog_id,
                    status: doc.status,
                }));
                await this.BuilderAiAgentService.setAgentGroundingToolSetup(this.state.id, this.action.$id, this.chunkSize, catalogs, documents);
                this.savedCatalogSetup = this.savedCatalogSetup || { catalogs: [], documents: [] };
                this.savedCatalogSetup.top_k = this.chunkSize;
                this.BlipToastService.show('success', {
                    title: this.$translate.instant('knowledgeBaseConsult.toasts.chunkSizeUpdateSuccess.title'),
                    msg: this.$translate.instant('knowledgeBaseConsult.toasts.chunkSizeUpdateSuccess.message'),
                });
            }
            catch (error) {
                console.error('Error saving chunk size:', error);
                this.BlipToastService.show('danger', {
                    title: this.$translate.instant('knowledgeBaseConsult.toasts.chunkSizeUpdateError.title'),
                    msg: this.$translate.instant('knowledgeBaseConsult.toasts.chunkSizeUpdateError.message'),
                });
            }
        };
        this.onChunkSizeChange = (event) => {
            const value = parseInt(event.detail.value, 10);
            let newValue = value;
            if (isNaN(value) || value < 3) {
                newValue = 3;
            }
            else if (value > 50) {
                newValue = 50;
            }
            this.chunkSize = newValue;
            this.$timeout(() => {
                const bdsInputElement = document.getElementById('studio-knowledge-base-chunk-size-input');
                if (bdsInputElement) {
                    bdsInputElement.value = String(newValue);
                    if (bdsInputElement.shadowRoot) {
                        const input = bdsInputElement.shadowRoot.querySelector('input');
                        if (input) {
                            input.value = String(newValue);
                        }
                    }
                }
                this.$rootScope.$applyAsync();
            }, 0);
        };
        this.onDescriptionChange = (event) => {
            const description = event.detail.value;
            this.action.$description = description;
            if (this.isAiAgentState) {
                this.showDescriptionError = !description || description.trim().length === 0;
            }
            this.save();
        };
        this.onInputTitleEditSave = (event) => {
            const title = event.detail.value;
            if (title.length > 0) {
                this.action.$title = title;
            }
            this.save();
        };
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.onOpenCatalogSelector = onOpenCatalogSelector;
        this.onCloseCatalogSelector = onCloseCatalogSelector;
        this.BuilderAiAgentService = BuilderAiAgentService;
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
        this.$timeout(() => {
            this.checkValidInputs();
            this.loadInitialSetup();
        });
    }
    async loadInitialSetup() {
        try {
            const catalogs = await this.BuilderAiAgentService.getCatalogsByToolId(this.state.id, this.action.$id);
            const filter = await this.BuilderAiAgentService.getAgentGroundingFilter(this.state.id, this.action.$id);
            if (filter?.top_k) {
                this.chunkSize = filter.top_k;
            }
            const activeCatalogs = catalogs?.filter((c) => c.status === 'active') || [];
            this.savedCatalogSetup = {
                top_k: this.chunkSize,
                catalogs: activeCatalogs,
            };
            this.selectedCatalogsCount = activeCatalogs.length;
            // Fetch catalogs with documents for the catalog selector
            await this.loadCatalogsWithDocuments();
        }
        catch (error) {
            this.savedCatalogSetup = null;
            this.selectedCatalogsCount = 0;
            this.catalogsWithDocuments = [];
        }
    }
    async loadCatalogsWithDocuments() {
        try {
            const catalogs = await this.BuilderAiAgentService.getCatalogsByToolId(this.state.id, this.action.$id);
            if (catalogs && catalogs.length > 0) {
                this.catalogsWithDocuments = await Promise.all(catalogs.map(async (catalog) => {
                    const documents = await this.BuilderAiAgentService.getCatalogDocumentsByToolId(catalog.id, this.state.id, this.action.$id);
                    return {
                        ...catalog,
                        documents: documents || [],
                        isLoading: false,
                    };
                }));
                // Apply saved selections to the loaded catalogs
                if (this.savedCatalogSetup) {
                    this.applySavedSelections();
                }
            }
            else {
                this.catalogsWithDocuments = [];
            }
        }
        catch (error) {
            console.error('Error loading catalogs with documents:', error);
            this.catalogsWithDocuments = [];
        }
    }
    applySavedSelections() {
        const savedCatalogs = this.savedCatalogSetup?.catalogs || [];
        const savedDocuments = this.savedCatalogSetup?.documents || [];
        this.catalogsWithDocuments.forEach(catalog => {
            const savedCatalog = savedCatalogs.find((c) => c.id === catalog.id);
            const isCatalogActive = savedCatalog ? savedCatalog.status === 'active' : catalog.status === 'active';
            catalog.documents?.forEach((doc) => {
                const isDocumentInactive = doc.status === 'inactive' || savedDocuments.some((d) => d.id === doc.id && (d.catalogId === catalog.id || d.catalog_id === catalog.id) && d.status === 'inactive');
                doc.selected = isCatalogActive && !isDocumentInactive;
            });
            catalog.hasSelectedDocuments = catalog.documents?.some((doc) => doc.selected) || false;
        });
    }
    create() {
        return new KnowledgeBaseConsultActionSettings();
    }
    checkValidInputs() {
        if (this.isAiAgentState) {
            this.showDescriptionError = !this.action.$description || this.action.$description.trim().length === 0;
        }
    }
    updateCatalogCount(count) {
        this.selectedCatalogsCount = count;
        const state = this.state;
        if (!state.$catalogSelectionData) {
            state.$catalogSelectionData = {};
        }
        state.$catalogSelectionData.selectedCatalogsCount = count;
        this.$timeout(() => {
            this.$rootScope.$applyAsync();
        });
    }
    async openCatalogSidebar() {
        if (this.onOpenCatalogSelector) {
            // Ensure catalogs are loaded before opening the sidebar
            if (!this.catalogsWithDocuments.length) {
                await this.loadCatalogsWithDocuments();
            }
            const state = this.state;
            if (!state.$catalogSelectionData) {
                state.$catalogSelectionData = {};
            }
            state.$catalogSelectionData.savedSetup = this.savedCatalogSetup;
            state.$catalogSelectionData.onSelectionChange = this.onCatalogSelectionChange;
            state.$catalogSelectionData.actionId = this.action.$id;
            state.$catalogSelectionData.catalogsWithDocuments = this.catalogsWithDocuments;
            this.$timeout(() => {
                this.onOpenCatalogSelector();
            });
        }
    }
    cancel() {
        if (this.onCloseCatalogSelector) {
            this.$timeout(() => {
                this.onCloseCatalogSelector();
            });
        }
        super.cancel();
    }
}
